import { useMemo } from 'react'

import { CONTROL_CENTRE_API_DOMAIN } from '@/config/constants'
import useAuthenticatedQuery from '@/hooks/useAuthenticatedQuery'
import type { AdminFlagItem, PaginatedResponse } from '@/types/controlCenter'

import { mapAdminFlags } from '../../utils/mappers'
import { QUERY_KEYS } from '../../utils/queryKeys'
import useAdminClients from '../../hooks/useAdminClients'
import type { FeatureFlag } from '@/types/controlCenter'

const useFeatureFlagsData = (): {
  flags: FeatureFlag[]
  isLoading: boolean
  isFetching: boolean
  error: Error | null
  url: string
} => {
  const { clientMap, isLoading: clientsLoading } = useAdminClients()

  const url = `${CONTROL_CENTRE_API_DOMAIN}/admin/feature_flags?page=0&size=100`

  const {
    data,
    isLoading: flagsLoading,
    isFetching,
    error,
  } = useAuthenticatedQuery<PaginatedResponse<AdminFlagItem>>(
    QUERY_KEYS.featureFlags,
    url,
    {
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
    },
  )

  const flags = useMemo(
    () =>
      data?.data && !clientsLoading ? mapAdminFlags(data.data, clientMap) : [],
    [data, clientMap, clientsLoading],
  )

  return {
    flags,
    isLoading: flagsLoading || clientsLoading,
    isFetching,
    error: error as Error | null,
    url,
  }
}

export default useFeatureFlagsData
